// extracted by mini-css-extract-plugin
module.exports = {"card":"_1czNj___ContactCardCTA-module__card","prompt":"zMPfD___ContactCardCTA-module__prompt"};